<template>
  <div class="outer-box" >
    <h4>Disable Feature for Agency</h4>
    <div class="inner-box" style="text-align: left; width: 620px;">
      <label>Company ID</label>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="k0EZ5XPBM9pACuERQRO5"
        v-model="companyId"
      />
      <label>Feature</label>
      <select
        class="hl_input--wrap"
        type="text"
        v-model="productKey"
      >
        <option value="contentAI">Content AI</option>
        <option value="workflow_premium_actions">LC Premium</option>
      </select>
      <button 
        class="btn btn-primary mt-4" 
        @click="disableFeature" 
        :disabled="!companyId || !productKey || processing">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else> Disable </span>
      </button>
      <pre 
        v-if="response" 
        style="background-color: #f2f7fa; padding-top: 16px; margin-top: 16px">
      {{response}}
    </pre>
    </div>
  </div>
</template>
  
<script>
  import { ProductRebillingService } from "@/services";
  export default {
    data() {
      return {
        companyId: '',
        processing: false,
        response: '',
        productKey: 'contentAI'
      }
    },
    methods: {
      async disableFeature(){
        try {
            this.response = ''
            this.processing = true
            const getData = 
              await ProductRebillingService.getByProduct(
                this.companyId , 
                'COMPANY' , 
                this.productKey
              );
            const currentData = getData.data.data
            if(currentData && currentData.length > 0) {
              const curConfig = currentData[0].config
              const {data} = 
                await ProductRebillingService.updateConfig(
                  this.companyId, 
                  { config: { ...curConfig ,enabled : false, optIn: false } , product: this.productKey }
                );
              if(data && data.message) {
                this.response = data.message
              } else {
                this.response = 'Something went wrong'
              }
            } else if(data && data.message){
              this.response = data.message
            } else {
              this.response = 'Something went wrong'
            }
        } catch (error) {
            alert(`An error has ocurred: ${JSON.stringify(error)}`);
            console.error(error);
        }finally{
            this.processing = false;
        }
      },
    }
  }
</script>

  